export default "__VITE_ASSET__Dw2jkIyC__"